import { useMutation } from '@tanstack/react-query'
import { createWallet } from 'services/WalletsService'

export const useCreateWalletMutation = () => useMutation({ mutationFn: createWallet })
